export enum AnalyticsEvent {
  ApplicationChanged = "application_changed",
  EmailConfirmed = "email_confirmed_with_magic_link",
  FeedbackSubmitted = "feedback_submitted",
  MagicLinkResent = "magic_link_resent",
  UnandledErrorThrown = "unhandled_error_thrown",
  FundingAdvisorContacted = "funding_advisor_contacted",
  OfferAccepted = "offer_accepted",
  OfferRejected = "offer_rejected",
  ApplicationStageViewed = "application_stage_viewed",
}
